import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Modal } from 'antd'
import { ComponentExt } from 'util/reactExt'
import LevelMode from './LevelMode'
import LevelConfig from './LevelConfig'
import StaffPassStatus from './StaffPassStatus'
import { ADVANCED_INFO } from 'constants/index'
import Url from 'util/url'
import { routeMap } from 'constants/routes'
import styles from './index.scss'
import newbieBanner from 'assets/check/bg.png'

const levelModeStyle = {
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'top center',
  minWidth: 1000,
}

const levelConfigStyle = {
  background: '#F0F2F5',
  opacity: 0.9,
}

const bannerImg = {
  newbie: newbieBanner,
  'regular-worker': newbieBanner,
  'elite-promotion': newbieBanner,
}

const modeStyle = {
  [routeMap.LEVEL_UP.LEVEL_MODE.path]: levelModeStyle,
  [routeMap.LEVEL_UP.LEVEL_CONRIG.path]: levelConfigStyle,
  [routeMap.LEVEL_UP.PASS_STATUS.path]: levelConfigStyle,
}

const needToCheck = {
  false: routeMap.LEVEL_UP.NORMAL_MODE.path,
  true: routeMap.LEVEL_UP.LEVEL_MODE.path + '?role=newbie',
}

interface ILevelupViewProps extends RouteComponentProps {}

@inject('globalStore', 'levelStore')
@observer
class LevelupView extends ComponentExt<ILevelupViewProps, any> {
  state = {
    visible: false,
  }

  static getDerivedStateFromProps = (nextProps): any => {
    LevelupView.refreshRoute(nextProps)
    return null
  }

  static refreshRoute = (props: any): void => {
    // const { globalStore: { staffInfo } } = props
    if (routeMap.LEVEL_UP.path === props.location.pathname) {
      // props.history.push(needToCheck['' + Boolean(staffInfo.need_to_check)]) //判断是否为新人，如果是新人进入飞行棋，否则返回首页
      // todo 根据员工{staffInfo.need_to_check}的状态判断是否为新人，开发环境默认为新人{staffInfo.need_to_check = true}
      props.history.push(needToCheck['' + true])
    }
  }

  componentDidMount() {
    LevelupView.refreshRoute(this.props)
  }

  openModal = () => {
    this.setState({
      visible: true,
    })
  }

  closeModal = () => {
    this.setState({
      visible: false,
    })
  }

  render() {
    const { location } = this.props
    const style = modeStyle[location.pathname]
    const type = Url.query()
    const role = type && type.role
    const isLevelMode = location.pathname === routeMap.LEVEL_UP.LEVEL_MODE.path

    return (
      <div
        className={styles.levelup}
        style={{
          ...style,
          backgroundImage: isLevelMode ? `url(${bannerImg[role]})` : 'none',
        }}
      >
        <div>
          {isLevelMode && (
            <section className={styles.bannerTxt}>
              <a
                onClick={this.openModal}
                className={styles.bannerAdvancedTxt}
              />
            </section>
          )}
          <LevelMode />
        </div>
        <div className={styles.content}>
          <LevelConfig />
          <StaffPassStatus />
        </div>
        <section className={''}>
          <Modal
            wrapClassName={'level-advanced-instruction'}
            visible={this.state.visible}
            title={'进阶说明'}
            footer={null}
            onOk={this.openModal}
            onCancel={this.closeModal}
          >
            {ADVANCED_INFO.map(info => (
              <div key={info[0]} className={styles.line}>
                <h4>{info[0]}</h4>
                {info.slice(1, info.length).map(text => (
                  <p key={text}>{text}</p>
                ))}
              </div>
            ))}
          </Modal>
        </section>
      </div>
    )
  }
}

export default withRouter(LevelupView)
